export interface IAnimatedButtonSettings {
    defaultClass: string;
    iconPosition: string;
    submittingClass: string;
    successClass: string;
    errorClass: string;
    submittingTimeOut: number;
    completedTimeOut: number;
    returnToDefaultState: boolean;
    enabledOnCompleted: boolean;
}

export const animatedButtonDefaultSettings: IAnimatedButtonSettings = {
    defaultClass: 'btn-primary',
    submittingClass: 'btn-info',
    successClass: 'btn-success',
    errorClass: 'btn-danger',
    iconPosition: 'left',
    submittingTimeOut: 200,
    completedTimeOut: 1000,
    returnToDefaultState: true,
    enabledOnCompleted: true
};

export interface ICssClasses {
    [cssClass: string]: boolean;
}
